export default "__VITE_ASSET__DviWLEX8__"